/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sage_Deft_Panda_BiteInputs */

const en_sage_deft_panda_bite = /** @type {(inputs: Sage_Deft_Panda_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure how this member receives and participates in surveys. The preferred channel determines the primary method for delivering survey invitations and reminders.`)
};

const de_sage_deft_panda_bite = /** @type {(inputs: Sage_Deft_Panda_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurieren Sie, wie dieses Benutzer Befragungen erhält und daran teilnimmt. Der bevorzugte Kanal bestimmt die primäre Methode für die Zustellung von Befragungseinladungen und Erinnerungen.`)
};

/**
* | output |
* | --- |
* | "Configure how this member receives and participates in surveys. The preferred channel determines the primary method for delivering survey invitations and rem..." |
*
* @param {Sage_Deft_Panda_BiteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sage_deft_panda_bite = /** @type {((inputs?: Sage_Deft_Panda_BiteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sage_Deft_Panda_BiteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sage_deft_panda_bite(inputs)
	return de_sage_deft_panda_bite(inputs)
});